<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_reward_actions, create_reward_action, delete_reward_action } from '@/services/reward_actions';
import { onMounted, ref } from 'vue';

const actionObj = ref({
  title: '',
  description: '',
  tag: '',
  point_value: 0
})

const actions = ref([])
const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_action()
  isLoading.value = false
})

async function retrieve_action(){
  let response = await get_reward_actions()
  if(response.error){
    swalError(response.result, true)
    return
  }
  actions.value = response.result.data.data
}

async function addAction(){
  let response = await create_reward_action(actionObj.value)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('New action has been added')
  actions.value.push(response.result.data.data)
}

async function deleteAction(id){
  let response = await delete_reward_action(id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Action has been deleted')
  let actionInd = actions.value.findIndex(item => item.id == id)
  actions.value.splice(actionInd, 1)
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Reward Action Setting"/>
    <div class="card">
      <form class="card-body" @submit.prevent="addAction()">
        <div class="d-flex align-items-center">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="point_value" class="pb-0 col-form-label">
                Title
              </label>
              <p class="mt-0 form-text">
                Use in reward history
              </p>
            </div>
            <div class="col-auto">
              <input type="text" 
                id="point_value" class="form-control"
                placeholder="Point value"
                v-model="actionObj.title"
              >
            </div>
          </div>
        </div>
        <div class="mt-2 row align-items-center">
          <div class="col-auto">
            <label for="point_value" class="pb-0 col-form-label">
              Description
            </label>
            <p class="mt-0 form-text">
              Use in for admin
            </p>
          </div>
          <div class="col-8">
            <input type="text" 
              id="point_value" class="form-control"
              placeholder="Point value"
              v-model="actionObj.description"
            >
          </div>
        </div>
        <div class="mt-2 d-flex align-items-center gap-3">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="point_value" class="pb-0 col-form-label">
                Tag / Slug
              </label>
              <p class="mt-0 form-text">
                Use by the system to know the action
              </p>
            </div>
            <div class="col-auto">
              <input type="text" 
                id="point_value" class="form-control"
                placeholder="Point value"
                v-model="actionObj.tag"
              >
            </div>
          </div>
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="point_value" class="pb-0 col-form-label">
                Point Value
              </label>
              <p class="mt-0 form-text">
                Amount of point rewarded to user
              </p>
            </div>
            <div class="col-auto">
              <input type="number" 
                id="point_value" class="text-end form-control"
                placeholder="Point value"
                v-model="actionObj.point_value"
              >
            </div>
          </div>
        </div>
        <div class="mt-2 d-flex justify-content-end">
          <button class="btn btn-light-success" type="submit">
            Add Action
          </button>
        </div>
      </form>
    </div>

    <div class="card">
      <loadingCard v-if="isLoading" />
      <div class="card-body" v-else>
        <EmptyCard v-if="actions.length == 0" />
        <template v-else>
          <div v-for="action in actions" :key="action.id" class="mb-2 card border shadow-none">
            <div class="card-body d-flex justify-content-between align-items-center">
              <div class="col-md-6">
                <p class="mb-0">{{ action.attributes.title }}</p>
                <p class="text-secondary">{{ action.attributes.description }}</p>
              </div>
              <div class="col-md-4">
                <p class="mb-0">
                  Point Value : 
                  <span class="text-secondary">{{ action.attributes.point_value }}</span>
                </p>
                <p>
                  Tag / Slug :
                  <span class="text-secondary">{{ action.attributes.tag }}</span>
                </p>
              </div>
              <div class="col-md-2">
                <router-link class="disabled btn btn-light-primary me-2"
                  :to="{name: 'reward-action', params: {id: action.id}}"
                >
                  View Action
                </router-link>
                <button class="btn btn-light-danger" @click="deleteAction(action.id)">
                  Delete Action
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>